import { render, staticRenderFns } from "./ShelfPlanogram.vue?vue&type=template&id=0c0eb6a6&scoped=true"
import script from "./ShelfPlanogram.vue?vue&type=script&lang=js"
export * from "./ShelfPlanogram.vue?vue&type=script&lang=js"
import style0 from "./ShelfPlanogram.vue?vue&type=style&index=0&id=0c0eb6a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0eb6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0eb6a6')) {
      api.createRecord('0c0eb6a6', component.options)
    } else {
      api.reload('0c0eb6a6', component.options)
    }
    module.hot.accept("./ShelfPlanogram.vue?vue&type=template&id=0c0eb6a6&scoped=true", function () {
      api.rerender('0c0eb6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/ShelfPlanogram.vue"
export default component.exports